module.exports = __webpack_public_path__ + "static/media/Varp-S.257fb051.jpg";